import { ITotalData } from '@/modules/mixing/ts/rustmix-buyer.types';

export const TooltipCardHeader = ({
  sum,
  classNumber,
  weight,
  targetMoistureData,
  pricePerTon,
  profitSum,
  totalData,
  cardIdx,
}: IArgs) => {
  const isNaNOrNull = (val: number) => (val === 0 || isNaN(val) ? true : false);
  const resProfit = Math.floor(totalData.resProfit);
  const isResPriceExists =
    totalData.resPrice && !isNaN(totalData.resPrice) && totalData.resPrice !== 0
      ? true
      : false;

  // к1 - цена отсутствует, к2 - цена есть, результат миксования - цена есть
  const case_1 =
    isNaNOrNull(totalData.bagAPrice) &&
    !isNaNOrNull(totalData.bagBPrice) &&
    isResPriceExists;

  // к1 - цена отсутствует, к2 - цена есть, результат миксования - цены нет
  const case_2 =
    isNaNOrNull(totalData.bagAPrice) &&
    !isNaNOrNull(totalData.bagBPrice) &&
    !isResPriceExists;

  // к1 - цена есть, к2 - цена отсутствует, результат миксования - цена есть
  const case_3 =
    !isNaNOrNull(totalData.bagAPrice) &&
    isNaNOrNull(totalData.bagBPrice) &&
    isResPriceExists;

  // к1 - цена есть, к2 - цена отсутствует, результат миксования - цены нет
  const case_4 =
    !isNaNOrNull(totalData.bagAPrice) &&
    isNaNOrNull(totalData.bagBPrice) &&
    !isResPriceExists;

  // к1 и к2 - цены неизвестны, результат миксования - цена есть
  const case_5 =
    isNaNOrNull(totalData.bagAPrice) &&
    isNaNOrNull(totalData.bagBPrice) &&
    !isNaNOrNull(totalData.resPrice);

  // к1 и к2 - цены неизвестны, результат миксования - цена есть, выгода - негативная
  const case_6 =
    !isNaNOrNull(totalData.bagAPrice) &&
    !isNaNOrNull(totalData.bagBPrice) &&
    !isNaNOrNull(totalData.resPrice) &&
    totalData.resProfit < 0;

  // цены вообще отсутствуют
  const case_7 =
    isNaNOrNull(totalData.bagAPrice) &&
    isNaNOrNull(totalData.bagBPrice) &&
    isNaNOrNull(totalData.resPrice);

  return (
    <>
      {/* {!!classNumber || !isNaN(+sum) ? (
        <FormulaTooltip
          sum={sum}
          weight={weight}
          targetMoistureData={targetMoistureData}
          pricePerTon={pricePerTon}
        />
      ) : resProfit > 0 && (!sum || isNaN(sum)) ? (
        <span style={{ color: '#000' }}>
          Цена не определена, из-за отсутствия соответствующего предложения от
          покупателей, но <span style={{ color: '#0870E2' }}>Компонент 1</span> может
          быть использован, для получения наиболее
          <span style={{ color: '#007E3C' }}> выгодного микса</span>, при миксовании с{' '}
          <span style={{ color: '#E73A42' }}>Компонентом 2</span>
        </span>
      ) : (
        <span style={{ color: '#000' }}>
          Цена не определена, из-за отсутствия соответствующего предложения от
          покупателей,{' '}
        </span>
      )} */}

      {case_1 ? (
        cardIdx === 1 ? (
          <CompromissTooltip />
        ) : cardIdx === 2 ? (
          <FormulaTooltip
            sum={sum}
            weight={weight}
            targetMoistureData={targetMoistureData}
            pricePerTon={pricePerTon}
          />
        ) : (
          <FormulaTooltip
            sum={sum}
            weight={weight}
            targetMoistureData={targetMoistureData}
            pricePerTon={pricePerTon}
            comment={1}
          />
        )
      ) : case_2 ? (
        cardIdx === 1 ? (
          <RejectTooltip />
        ) : cardIdx === 2 ? (
          <FormulaTooltip
            sum={sum}
            weight={weight}
            targetMoistureData={targetMoistureData}
            pricePerTon={pricePerTon}
          />
        ) : (
          <RejectTooltip comment={1} />
        )
      ) : case_3 ? (
        cardIdx === 1 ? (
          <FormulaTooltip
            sum={sum}
            weight={weight}
            targetMoistureData={targetMoistureData}
            pricePerTon={pricePerTon}
          />
        ) : cardIdx === 2 ? (
          <CompromissTooltip />
        ) : (
          <FormulaTooltip
            sum={sum}
            weight={weight}
            targetMoistureData={targetMoistureData}
            pricePerTon={pricePerTon}
            comment={2}
          />
        )
      ) : case_4 ? (
        cardIdx === 1 ? (
          <FormulaTooltip
            sum={sum}
            weight={weight}
            targetMoistureData={targetMoistureData}
            pricePerTon={pricePerTon}
          />
        ) : cardIdx === 2 ? (
          <RejectTooltip />
        ) : (
          <RejectTooltip comment={2} />
        )
      ) : case_5 ? (
        cardIdx === 1 ? (
          <RejectTooltip />
        ) : cardIdx === 2 ? (
          <RejectTooltip />
        ) : (
          <FormulaTooltip
            sum={sum}
            weight={weight}
            targetMoistureData={targetMoistureData}
            pricePerTon={pricePerTon}
            comment={'all'}
          />
        )
      ) : case_6 ? (
        cardIdx === 1 ? (
          <FormulaTooltip
            sum={sum}
            weight={weight}
            targetMoistureData={targetMoistureData}
            pricePerTon={pricePerTon}
          />
        ) : cardIdx === 2 ? (
          <FormulaTooltip
            sum={sum}
            weight={weight}
            targetMoistureData={targetMoistureData}
            pricePerTon={pricePerTon}
          />
        ) : (
          <NoProfitTooltip />
        )
      ) : case_7 ? (
        <RejectTooltip />
      ) : (
        <FormulaTooltip
          sum={sum}
          weight={weight}
          targetMoistureData={targetMoistureData}
          pricePerTon={pricePerTon}
        />
      )}
    </>
  );
};

interface IArgs {
  sum: number;
  classNumber: number;
  weight: number;
  targetMoistureData: any;
  pricePerTon: number;
  profitSum: string | number | undefined;
  totalData: ITotalData;
  cardIdx?: number;
}

function FormulaTooltip({
  sum,
  weight,
  targetMoistureData,
  pricePerTon,
  comment,
}: {
  sum: number;
  weight: number;
  targetMoistureData: any;
  pricePerTon: number;
  comment?: 1 | 2 | 'all';
}) {
  return (
    <div style={{ color: '#000', fontWeight: 600 }}>
      {comment === 1 ? (
        <span>
          <CompOneTag /> не может быть оценен (нет соответствующего предложения), но
          может быть использован, для удорожания <CompTwoTag changed={true} />, при
          миксовании одного с другим - выгода составляет:
        </span>
      ) : comment === 2 ? (
        <span>
          <CompTwoTag /> не может быть оценен (нет соответствующего предложения), но
          может быть использован, для удорожания <CompOneTag changed={true} />, при
          миксовании одного с другим - выгода составляет:
        </span>
      ) : comment === 'all' ? (
        <span>
          <CompOneTag /> продать отдельно нет возможности, так же как и <CompTwoTag />,
          но их микс продать возможно по цене 2 060 000 рублей.
        </span>
      ) : null}
      <span style={{ display: 'block' }}>
        {sum.toLocaleString('ru')}₽ = ( {weight}т
        <sup style={{ color: '#007E3C' }}>1</sup>{' '}
        {`${targetMoistureData.weightGain > 0 ? '+' : '-'} ${Math.abs(
          targetMoistureData.weightGain,
        )}т`}
        <sup style={{ color: '#007E3C' }}>2</sup> ) × {pricePerTon.toLocaleString('ru')}
        ₽/т
        <sup style={{ color: '#007E3C' }}>3</sup>
      </span>
      <div style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 600 }}>{weight}т</span>
        <sup style={{ color: '#007E3C' }}>1</sup> - вес пшеницы
      </div>
      <div style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 600 }}>
          {Math.abs(targetMoistureData.weightGain)}т
        </span>
        <sup style={{ color: '#007E3C' }}>2</sup> -{' '}
        {+targetMoistureData.weightGain > 0 ? 'прибавка веса' : 'потеря веса'}
      </div>
      <div style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 600 }}>{pricePerTon.toLocaleString('ru')}₽/т</span>
        <sup style={{ color: '#007E3C' }}>3</sup> - стоимость зерна покупателя
      </div>
    </div>
  );
}

function CompromissTooltip() {
  return (
    <span style={{ color: '#000' }}>
      Цена не определена, из-за отсутствия соответствующего предложения от покупателей,
      но <CompOneTag /> может быть использован, для получения наиболее
      <span style={{ color: '#007E3C' }}> выгодного микса</span>, при миксовании с{' '}
      <span style={{ color: '#E73A42', fontWeight: 600 }}>Компонентом 2</span>
    </span>
  );
}

function RejectTooltip({ comment }: { comment?: 1 | 2 }) {
  return (
    <>
      <span style={{ color: '#000', display: 'block' }}>
        Цена не определена, из-за отсутствия соответствующего предложения от
        покупателей.
      </span>
      <span style={{ color: '#000' }}>
        {comment === 1 ? (
          <span>
            <CompOneTag /> продать отдельно нет возможности, так же как его микс с
            <span style={{ color: '#E73A42', fontWeight: 600 }}> Компонентом 2</span>,
            поэтому выгодней продать <CompTwoTag /> по отдельности от
            <CompOneTag changed={true} />
          </span>
        ) : comment === 2 ? (
          <span>
            <CompTwoTag /> продать отдельно нет возможности, так же как его микс с
            <span style={{ color: '#0870E2', fontWeight: 600 }}> Компонентом 1</span>,
            поэтому выгодней продать <CompOneTag /> по отдельности от
            <CompTwoTag changed={true} />
          </span>
        ) : null}
      </span>
    </>
  );
}

function NoProfitTooltip() {
  return (
    <span style={{ color: '#000' }}>
      <CompOneTag /> и <CompTwoTag /> выгоднее продать по отдельности, нежели их микс
    </span>
  );
}

var CompOneTag = ({ changed = false }: { changed?: boolean }) => (
  <span style={{ color: '#0870E2', fontWeight: 600 }}>
    {changed ? ' Компонента' : ' Компонент'} 1
  </span>
);
var CompTwoTag = ({ changed = false }: { changed?: boolean }) => (
  <span style={{ color: '#E73A42', fontWeight: 600 }}>
    {changed ? ' Компонента' : ' Компонент'} 2
  </span>
);
